import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-03/lesson-07/task-03";

const task: Slide = {
  titleHtml:
    "The room size, its contents and its surface material impacts the length of the room's reverberation.<br>Please decide which lead to longer or shorter reverberation times.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
